var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box",class:_vm.className,style:({
        marginTop: _vm.data.marginTop + 'px',
        paddingTop: _vm.data.paddingTop + 'px',
        paddingLeft: _vm.data.paddingLeft + '%',
        paddingRight: _vm.data.paddingRight + '%',
    })},[(_vm.data.data && _vm.data.data.length > 0)?_vm._l((_vm.data.data),function(item,index){return _c('a',{key:index,attrs:{"href":item.link}},[_c('img',{attrs:{"src":item.url}})])}):[_vm._m(0)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-null"},[_c('span',{staticClass:"el-icon-picture"})])}]

export { render, staticRenderFns }